<template>
  <v-container fluid>
    <h1>
      <v-icon>mdi-chart-timeline</v-icon>ผลหวย
    </h1>

    <v-row>
      <v-col cols="12" lg="4" xl="2">
        <v-card>
          <v-card-title>เลือกวันที่</v-card-title>
          <v-card-subtitle>วันที่ต้องการดูผลหวย</v-card-subtitle>
          <v-card-text>
            <v-date-picker
              full-width
              locale="th"
              v-model="selected_date"
              elevation="5"
              @change="loadResults"
            ></v-date-picker>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="8" xl="10">
        <v-card>
          <v-card-title>รายการผลหวยประจำวัน{{ displayDate }}</v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>หมวดหมู่</th>
                    <th>หวย</th>
                    <th>วันที่/เวลา</th>
                    <th>เลขที่ออก</th>
                    <th>4 ตัวบน</th>
                    <th>3 ตัวบน</th>
                    <th>2 ตัวบน</th>
                    <th>2 ตัวล่าง</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="loading">
                    <td colspan="8" class="text-center">
                      <v-progress-circular indeterminate color="primary" class="my-2"></v-progress-circular>
                      <p>กำลังโหลดข้อมูลกรุณารอสักครู่...</p>
                    </td>
                  </tr>
                  <tr v-show="!loading && result_list.length == 0">
                    <td colspan="8" class="text-center">ไม่พบข้อมูลในระบบ</td>
                  </tr>
                  <tr v-show="!loading" v-for="r in result_list" :key="r.id">
                    <td>{{ r.cate_name }}</td>
                    <td>{{ r.name }}</td>
                    <td>{{ r.result_time }}</td>
                    <td>{{ r.result || "-" }}</td>
                    <td>{{ r.four_result || "-" }}</td>
                    <td>{{ r.three_result || "-" }}</td>
                    <td>{{ r.two_up_result || "-" }}</td>
                    <td>{{ r.two_down_result || "-" }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => {
    return {
      loading: false,
      selected_date: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    displayDate() {
      return moment(this.selected_date).format("dddd LL");
    },
    ...mapGetters("lottoResult", ["result_list"]),
  },
  created() {
    document.title = "ผลหวย";

    this.loadResults();
  },
  methods: {
    ...mapActions("lottoResult", ["getResults"]),
    async loadResults() {
      this.loading = true;
      try {
        const data = await this.getResults(this.selected_date);
        if (data.success && data.success === true) {
          this.$notify({
            type: "success",
            title: "สำเร็จ",
            text: "โหลดข้อมูลเรียบร้อย",
          });
        } else if (!data.success && data.message) {
          this.$notify({
            type: "error",
            title: "Error",
            text: data.message,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
          });
        }
      } catch (err) {
        const errMsg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          err.message ||
          "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
        this.$notify({
          type: "error",
          title: "Error",
          text: errMsg,
        });
      }
      this.loading = false;
    },
  },
};
</script>
